export default __webpack_public_path__ + "static/media/error.8d8312a4.svg";